import styles from '@/styles/productDetail/newArrivals.module.scss'
import { Rate } from 'antd'
import { useEffect, useState } from 'react';
import productApi from '@/service/modules/productApi'
import Link from 'next/link'
import { Image } from 'antd';

export default function NewArrivals(props: any) {
  // 监听是否在两个元素之间、要做吸顶处理
  const [isBetween, setIsBetween] = useState(false);
  const [arrivalList, setArrivalList] = useState([])

  useEffect(() => {
    const handleScroll = () => {
      const element1 = document.getElementById('detail-ad');
      const element2 = document.getElementById('product-recommend');
      const newArrivals = document.getElementById('newArrivals');
      const detailAdBox = document.getElementById('detail-ad-box');
      const contentBox = arrivalList.length > 0 ? newArrivals : detailAdBox
      const scrollPosition = window.scrollY;

      if (element1 && element2) {
        const rect1 = element1.getBoundingClientRect();
        const rect2 = element2.getBoundingClientRect();

        const newArrivalsRect = contentBox ? contentBox.getBoundingClientRect() : { height: 0 }
        if (scrollPosition > (arrivalList.length > 0 ? rect1.bottom : rect1.top) + scrollPosition && scrollPosition < (rect2.top - newArrivalsRect.height - 25) + scrollPosition) {
          setIsBetween(true);
        } else {
          setIsBetween(false);
        }
      }
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [arrivalList]);

  // 监测宽度变化
  useEffect(() => {
    function handleResize() {
      const goodsDetailInfoRight = document.getElementById("goods-detail-info-right")
      if (goodsDetailInfoRight) {
        const width = goodsDetailInfoRight.getBoundingClientRect().width
        const newArrivals = document.getElementById("newArrivals")
        const detailAd = document.getElementById("detail-ad-box")
        if (newArrivals) {
          newArrivals.style.width = `${width}px`
        }
        if (detailAd) {
          detailAd.style.width = `${width}px`
        }
      }
    }

    handleResize();
    const debouncedHandleResize = handleResize
    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);

  // 待页面onload再请求接口
  useEffect(() => {
    function handleWindowLoad() {
      getArrivalList()
      getAdimage()
    }
    
    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  // 获取New Arrival数据
  const getArrivalList = async () => {
    try {
      const res = await productApi.getRecommendProduct(props.categoryId)
      if (res.data && res.data.length) {
        setArrivalList(res.data.splice(0, 5))
      }
    } catch (error: any) {
      console.log(error);
    }
  }

  const [adImageArr, setAdImageArr] = useState([])
  const getAdimage = async () => {
    try {
      const res = await productApi.detailRightBox()
      const { banner } = res.data
      setAdImageArr(banner)
    } catch (error: any) {
      console.log(error);
    }
  }

  return (
    <>
      <div id="detail-ad">
        <div className={`${styles['detail-ad-box']} ${(isBetween && arrivalList.length == 0) && styles['fixed']}`} id="detail-ad-box">
          {
            adImageArr.map((item: any, index: number) => {
              if (item.url) {
                return (
                  <Link
                    href={item.url}
                    legacyBehavior
                    key={index}
                  >
                    <a rel="noopener noreferrer" target="_blank">
                      <Image
                        alt={item.image}
                        src={item.image}
                        preview={false}
                      />
                    </a>
                  </Link>
                )
              } else {
                return (
                  <Image
                    alt={item.image}
                    src={item.image}
                    preview={false}
                    key={index}
                    className={styles['only-img']}
                  />
                )
              }
            })
          }
        </div>
      </div>
      <div className={`${styles['newArrivals']} ${isBetween && styles['fixed']}`} style={{ opacity: arrivalList.length > 0 ? 1 : 0 }} id="newArrivals">
        <div className={styles['arrivalsHot-box']}>
          <div className={styles['title']}>New Arrivals & Hot</div>
          <div className={styles['goodsList']}>
            {
              arrivalList.map((item: any, index: number) => (
                <div className={styles['goodsItem']} key={index}>
                  <div className={styles['img']}>
                    <Link
                      href={item.url}
                      legacyBehavior
                    >
                      <a rel="noopener noreferrer">
                        <Image
                          alt={item.name}
                          src={`${item.thumbnail || item.filename}`}
                          preview={false}
                        />
                      </a>
                    </Link>
                  </div>
                  <div className={styles['goods-info']}>
                    <div className={styles['goodsName']}>
                      <Link
                        href={item.url}
                        legacyBehavior
                      >
                        <a rel="noopener noreferrer">{item.name}</a>
                      </Link>
                    </div>
                    <div className={styles['price']}>${item.price}</div>
                    <div className={styles['rate']}>
                      {
                        !!(item.review && item.review.avgRank > 0)
                        &&
                        <Rate 
                          count={5}
                          value={item.review ? item.review.avgRank : 0}
                          className={styles['rate-list']}
                          allowHalf={true}
                          disabled
                        />
                      }
                      {
                        !!(item.review && item.review.total > 0)
                        &&
                        <span className={styles['commitNum']}>({item.review ? item.review.total : 0})</span>
                      }
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </>
  )
}